import { render } from "./BugReports.vue?vue&type=template&id=51761b8d&scoped=true"
import script from "./BugReports.vue?vue&type=script&lang=js"
export * from "./BugReports.vue?vue&type=script&lang=js"

import "./BugReports.vue?vue&type=style&index=0&id=51761b8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51761b8d"]])

export default __exports__